import type {ReloaderService} from 'shared/services';
import type LoanService from '../loan.service';

export class LoansPageService {
    public static serviceName = 'loansPageService';

    /*@ngInject*/
    constructor(private loanService: LoanService,
                private reloader: ReloaderService) {
    }

    public async processLoan(): Promise<void> {
        await this.loanService.processLoan();
        await this.reloader.reloadRoute();
    }
}